/**
 * Splits a service's time into the segments the Gantt bar is drawn from.
 *
 * The estimate to compare against is completedEstimatedMinutes, not
 * estimatedMinutes: the latter is zero on most records, and minutesOverTime is
 * calculated by the backend as elapsedMinutes minus completedEstimatedMinutes.
 */
export const getServiceTimeBreakdown = (service = {}) => {
	const estimated = Math.max(
		service.completedEstimatedMinutes || service.estimatedMinutes || 0,
		0
	);
	const elapsed = Math.max(service.elapsedMinutes || 0, 0);

	return {
		estimated,
		elapsed,
		// Time spent inside the estimate
		used: Math.min(elapsed, estimated),
		// Estimated time the role did not need
		unused: Math.max(estimated - elapsed, 0),
		// Time spent beyond the estimate
		overrun: Math.max(elapsed - estimated, 0),
		// What the bar has to span to show both
		total: Math.max(estimated, elapsed),
	};
};

/**
 * Turns a breakdown into the widths the bar segments render at, as
 * percentages that always add up to 100.
 */
export const getServiceTimeSegments = (breakdown) => {
	const { total, used, unused, overrun } = breakdown;
	if (!total) return { used: 0, unused: 0, overrun: 0 };

	const toPercent = (value) => (value / total) * 100;
	const usedPercent = toPercent(used);
	const overrunPercent = toPercent(overrun);

	return {
		used: usedPercent,
		// Absorbs any rounding so the segments always fill the bar
		unused: Math.max(100 - usedPercent - overrunPercent, 0),
		overrun: overrunPercent,
	};
};
